import { render, staticRenderFns } from "./product-add.vue?vue&type=template&id=342b9352&"
import script from "./product-add.vue?vue&type=script&lang=js&"
export * from "./product-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports